import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/index/index'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/home',
      component: Layout,
      redirect: '/home',
      children: [{
        path: 'index',
        name: '主页',
        component: () => import( '@/views/Home/index')
      }]
    },
    {
      path: '/enterpriseRegister',
      component: Layout,
      redirect: '/enterpriseRegister/index',
      children: [{
        path: 'index',
        name: '企业注册落地',
        component: () => import('@/views/enterpriseRegister/index'),
      },{
        path: 'form',
        name: '企业注册落地表单',
        component: () => import('@/views/enterpriseRegister/form')
      }]
    },
    {
      path: '/station',
      component: Layout,
      redirect: '/station/index',
      children: [{
        path: 'index',
        name: '免费过渡工位',
        component: () => import( '@/views/Station/index')
      },{
        path: 'form',
        name: '免费过渡工位表单',
        component: () => import('@/views/Station/form')
      }]
    },
    {
      path: '/housekeeper',
      component: Layout,
      redirect: '/housekeeper/index',
      children: [{
        path: 'index',
        name: '管家式服务',
        component: () => import( '@/views/Housekeeper/index')
      },{
        path: 'form',
        name: '管家式服务表单',
        component: () => import('@/views/Housekeeper/form')
      }]
    },
    {
      path: '/field',
      component: Layout,
      redirect: '/field/index',
      children: [{
        path: 'index',
        name: '校友活动场地',
        component: () => import( '@/views/Field/index')
      },{
        path: 'form',
        name: '校友活动场地表单',
        component: () => import('@/views/Field/form')
      }]
    },
    {
      path: '/',
      name: '主页',
      redirect: '/home/index'
    }/* ,
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home/index.vue')
    } */
  ],
})
router.afterEach((to, from) => {
  let bodySrcollTop = document.body.scrollTop
  if (bodySrcollTop !== 0) {
    document.body.scrollTop = 0
    return
  }
  let docSrcollTop = document.documentElement.scrollTop
  if (docSrcollTop !== 0) {
    document.documentElement.scrollTop = 0
  }
})
router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0; // firefox
  document.documentElement.scrollTop = 0; // safari
  window.pageYOffset = 0; // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁
  next();
  });
  


/* //登录例子 需要用 不需要就删除
// 判断是否需要登录权限 以及是否登录
 router.beforeEach((to, from, next) => {
   // 判断是否需要登录权限
   if (to.matched.some(res => res.meta.requireAuth)) {
     // 判断是否登录
     if (sessionStorage.getItem('token')) {
       next()
     } else {
       // 没登录则跳转到登录界面
       next({
         path: '/login',
         query: {
           redirect: to.fullPath
         }
       })
     }
   } else {
     next()
   }
 }) */

export default router